/**
 * Accounts v2 (ACT HQ DR-0009 as changed 29 Sep 2026, act-babylon DR-0053):
 * Google sign-in through Supabase, the Account ID (the account's zkLogin Sui
 * address, which the home game server gets from Enoki with the Google token of
 * the first sign-in) and Sui addresses linked with a signed message ("Link
 * Sui"). HTTP contracts between a page and the home game server.
 */

/**
 * The Google OAuth web client "ACT web" (Google Cloud project `act-universe`,
 * owned by theo@paradoxstate.co.uk). Not a secret. Permanent: it is the `aud`
 * of every Account ID, so a new client would give every player a new address.
 */
export const ACT_GOOGLE_CLIENT_ID = "305666393183-gsv0kik3df0lhk13gcl4m6tts10g3p2k.apps.googleusercontent.com";

/** `account`: the Account ID (one per account, never moves). `linked`: added with "Link Sui". */
export type SuiAddressKind = "account" | "linked";

/** A row of `account_sui_addresses` as its owner reads it. */
export type AccountSuiAddress = { address: string; kind: SuiAddressKind };

/**
 * POST /account/id — make (or return) the signed-in account's Account ID. Making
 * it needs the Google ID token of this sign-in; returning an existing one doesn't.
 */
export type AccountIdRequest = { idToken?: string };
export type AccountIdResponse = { accountId: string };

/** POST /account/sui/link — a message from {@link suiLinkMessage}, signed by `address`. */
export type SuiLinkRequest = { address: string; message: string; signature: string };
/** `moved`: the address was on another ACT account; the fresh signature moved it here. */
export type SuiLinkResponse = { address: string; moved: boolean };

/**
 * POST /account/chain/refresh — read what the account's Sui addresses hold (its
 * Account ID and every linked address) into its entitlements (ACT HQ t-042,
 * DR-0088). `items`: the catalogue and outfit ids the chain gives the account
 * now. `changed`: rows were added or removed, so the client reads them again.
 */
export type ChainRefreshResponse = { items: string[]; addresses: number; changed: boolean };

export type AccountErrorCode =
  | "unauthenticated"
  | "origin_rejected"
  | "invalid_request"
  | "invalid_token"
  | "identity_mismatch"
  | "sign_in_first"
  | "stale_message"
  | "bad_signature"
  | "address_is_account_id"
  | "account_id_unavailable"
  | "unavailable";
